import React, { useState } from "react";
import { PulseLoader } from "react-spinners";
import { loginOtpVerification } from "../../services/auth";
import { useNavigate } from "react-router-dom";

const VerifyOtpModal = ({ closeModal, email }) => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [loader, setLoader] = useState(false);
  const [verifyError, setVerifyError] = useState("");

  const handleOtpSubmit = async () => {
    setLoader(true);
    setIsSubmit(true);
    if (otp !== "") {
      const submitOtpResponse = await loginOtpVerification({
        email: email,
        otp,
      });
      const { status, data } = submitOtpResponse;
      if (status === 200) {
        localStorage.setItem("token", data?.token);
        localStorage.setItem("role", data?.role);
        localStorage.setItem("userDetails", JSON.stringify(data?.data));
        localStorage.setItem("session", "not_expired");
        navigate("/admin");
      } else {
        setVerifyError(data.message);
      }
      setLoader(false);
    }
  };

  return (
    <div className="relative w-full max-w-md max-h-full">
      <div className="relative bg-white ">
        <div className="p-4 md:p-5 space-y-4">
          <div>
            {isSubmit && otp === "" && (
              <h4 className="text-center text-red-700 text-sm my-2">
                Please Enter Otp
              </h4>
            )}
            <input
              type="text"
              name="otp"
              value={otp}
              onChange={(e) => {
                setVerifyError("");
                setOtp(e.target.value);
              }}
              id="email"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#619269] focus:border-[#619269] block w-full p-2.5"
              placeholder="Enter OTP here.."
              required
            />
          </div>
          <div>
            <h1 className="text-center text-xs text-red-600">{verifyError}</h1>
          </div>
          <button
            onClick={handleOtpSubmit}
            className="w-full text-white bg-[#619269] hover:bg-[#619269] focus:ring-4 focus:outline-none focus:ring-[#619269] font-medium rounded-lg text-sm px-5 py-2.5 text-center"
          >
            {loader ? (
              <PulseLoader color="#fff" size={9} speedMultiplier={1} />
            ) : (
              "Continue"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerifyOtpModal;
